module.exports = require('../lib/locale/zh_CN');